import { Component, OnInit, Inject, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from '../../services/api.service';
import { GlobalService } from '../../services/global.service';
import { ToastrService } from 'ngx-toastr';
import { UntypedFormGroup, UntypedFormControl, Validators, AbstractControl } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'sd-report-dialog',
    templateUrl: './report-dialog.component.html',
    styleUrls: ['./report-dialog.component.scss']
})

export class ReportDialogComponent implements OnInit {

    complaints = [
        'Copyright Infringement',
        'Abusive Image',
        'Abusive Videos',
        'Abusive Lyrics',
        'Scam',
        'Harrassment',
        'Spam',
        'Unwanted Contact by Adult',
        'Others'
    ];
    complaintSelected: string;

    processing: Boolean = false;

    reportForm: UntypedFormGroup;
    reportError: Boolean = false;
    reportErrorMsg: String = '';

    recaptchaError: Boolean = false;
    formSubmit: boolean;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<ReportDialogComponent>,
        public global: GlobalService,
        private api: ApiService,
        private el: ElementRef,
        private toastrService: ToastrService,
        private user: UserService
    ) {
        this.reportForm = new UntypedFormGroup({
            url: new UntypedFormControl('', [
                Validators.required
            ]),
            complaint: new UntypedFormControl('', [
                Validators.required
            ]),
            description: new UntypedFormControl('', [
                Validators.required
            ]),
            name: new UntypedFormControl(this.user.name, [
                Validators.required
            ]),
            email: new UntypedFormControl(this.user.email, [
                Validators.required,
                Validators.email,
                Validators.pattern(this.global.emailRegex)
            ]),
            mobile: new UntypedFormControl(this.user.mobile, [
                this.validMobile.bind(this)
            ]),
            recaptchaReactive: new UntypedFormControl(null, Validators.required)
        });
    }

    get url() { return this.reportForm.get('url'); }
    get complaint() { return this.reportForm.get('complaint'); }
    get description() { return this.reportForm.get('description'); }
    get name() { return this.reportForm.get('name'); }
    get email() { return this.reportForm.get('email'); }
    get mobile() { return this.reportForm.get('mobile'); }
    get recaptchaReactive() { return this.reportForm.get('recaptchaReactive'); }


    ngOnInit() {
    }

    onReportFormSubmit() {
        this.formSubmit = true;
        if (this.reportForm.valid) {
            // console.log(this.reportForm.value);

            this.repostAbuse();
        } else {
            if (this.reportForm.value.recaptchaReactive == null) {
                this.recaptchaError = true;
            } else {
                this.recaptchaError = false;
            }

            const target = this.el.nativeElement.querySelector('.reportForm .ng-invalid');
            if (target) {
                this.global.scrollToElem('.reportForm .ng-invalid', 300, '.mat-dialog-container');
            }
        }
    }

    repostAbuse() {
        this.processing = true;

        this.api.reportAbuse(
            this.reportForm.value.url,
            this.reportForm.value.complaint,
            this.reportForm.value.description,
            this.reportForm.value.name,
            this.reportForm.value.email,
            this.reportForm.value.mobile,
            this.reportForm.value.recaptchaReactive
        ).subscribe(res => {
            // console.log(res);

            this.processing = false;
            if (res.success) {
                this.closeDialog();
                this.toastrService.success('Reported successfully');
            } else {
                this.reportError = true;
                this.reportErrorMsg = res.error;
            }
        },
            (err: HttpErrorResponse) => {
                this.processing = false;
                this.reportError = true;
                if (err.error instanceof Error) {
                    this.reportErrorMsg = 'Client-side error occured!';
                    // console.log('Client-side error occured!');
                } else {
                    this.reportErrorMsg = 'Server-side error occured!';
                    // console.log('Server-side error occured!');
                }
            });
    }

    closeDialog() {
        this.dialogRef.close();
    }

    dropvalueValidate(value: any) {

        this.complaintSelected = value;
        this.reportForm.patchValue({
            complaint: value
        });
    }



    validSongTitle(control: AbstractControl): { [key: string]: boolean } | null {
        let value;
        if (control.value != null) {
            value = control.value.trim();
        } else {
            value = '';
        }

        if (value == '') {
            return { 'validSongTitle': true };
        } else if (!this.global.titleCharRegex.test(control.value)) {
            return { 'validSongTitle': true };
        }
        return null;
    }

    validMobile(control: AbstractControl): { [key: string]: boolean } | null {
        if (control.value.length > 0 && control.value.length != 10) {
            return { 'validMobile': true };
        } else if (isNaN(control.value)) {
            return { 'validMobile': true };
        }

        return null;
    }
}
